export function toPx(pixelValue: number): string {
    return pixelValue + "px";
}
